export default "__VITE_ASSET__Ck3gTvhx__"